import axios from "axios";
import { getCompany } from "@utils/common";
import { TokenKey } from "@/constants";
import { notifyError } from "@/utils/notification";

const instance = axios.create({
  timeout: 60000,
});
instance.interceptors.request.use(
  function (config) {
    // 优先从 sessionStorage 获取 token（兼容旧登录）
    let token = sessionStorage.getItem("token");

    // 如果 sessionStorage 中没有，尝试从 localStorage 获取（兼容新登录）
    if (!token) {
      token = localStorage.getItem(TokenKey);
    }

    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // 安全地获取错误消息
    const errorMsg = error?.response?.data?.message || "请求失败，请稍后重试";
    notifyError(errorMsg);
    return Promise.reject(error);
  },
);
export const getApi =
  (url: string) =>
  (...arg: any[]) =>
    instance.get(url, ...arg);

export const postApi =
  (url: string) =>
  (...arg: any[]) => {
    return instance.post(url, ...arg);
  };
export const postApiForCompany =
  (url: string) =>
  (data: any = {}, ...arg: any[]) => {
    return instance.post(url, { ...data, company: getCompany().code }, ...arg);
  };
export default instance;
